'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'bath';
var width = 512;
var height = 512;
var aliases = [128705,"bathtub"];
var unicode = 'f2cd';
var svgPathData = 'M56 0l-24 0 0 256-32 0 0 48 32 0 0 64c0 28.4 12.4 54 32 71.6l0 72.4 48 0 0-49.3c5.2 .9 10.5 1.3 16 1.3l256 0c5.5 0 10.8-.5 16-1.3l0 49.3 48 0 0-72.4c19.6-17.6 32-43.1 32-71.6l0-64 32 0 0-48-432 0 0-208 30.1 0 11 11c-5.8 11.1-9.1 23.7-9.1 37 0 23.6 10.2 44.9 26.5 59.5l-12.5 12.5 33.9 33.9 17-17 104-104 17-17-33.9-33.9-12.5 12.5c-14.6-16.3-35.9-26.5-59.5-26.5-13.4 0-25.9 3.3-37 9.1L129.9 0 56 0zM217.5 76.6l-44.8 44.8c-7.7-5.8-12.6-15.1-12.6-25.5 0-17.7 14.3-32 32-32 10.4 0 19.6 4.9 25.5 12.6zM80 304l352 0 0 64c0 26.5-21.5 48-48 48l-256 0c-26.5 0-48-21.5-48-48l0-64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBath = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;